import type { GlbSceneConfig } from './glbSceneConfig';

const glbSceneConfigs: Record<string, GlbSceneConfig> = {};

export const getGlbSceneConfig = (id: string): GlbSceneConfig | undefined =>
  glbSceneConfigs[id];

export const isGlbScene = (id: string): boolean => id in glbSceneConfigs;
